import { ModelSpellingDao } from '@rock/db-admin';
import { linkedDocumentIds } from '@rock/manuals';
import type { ModelDocumentId, ModelSpellingKey } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { modelState } from './catalog.state';

const modelSpellingDao = new ModelSpellingDao();

/** A number's `model-spellings` projection, live — the other models that share a model's spelling key. */
export const modelSpellingState = atomFamily(
    (spellingKey: ModelSpellingKey | undefined) => modelSpellingDao.modelSpellingAtom(spellingKey),
    shallowEqual,
);

/** Every document linked to a model under one number's spelling key — the documents list's number search. */
export const documentIdsForSpellingState = atomFamily(
    (spellingKey: ModelSpellingKey | undefined) =>
        atom(async (get): Promise<ModelDocumentId[]> => {
            if (!spellingKey) return [];
            const spelling = await get(modelSpellingState(spellingKey));
            const models = await Promise.all((spelling?.entries ?? []).map((entry) => get(modelState(entry.modelId))));
            return [...new Set(models.flatMap((model) => linkedDocumentIds(model)))];
        }),
    shallowEqual,
);
